import { api } from "@/lib/api";

export const DEFAULT_PRICING = {
  price: 29.9,
  original_price: 39.9,
  promo_active: true,
  promo_label: "Offerta lancio",
};

export const formatPrice = (v) => `€ ${Number(v ?? 0).toFixed(2).replace(".", ",")}`;

export const hasPromo = (p) => !!p?.promo_active && Number(p?.original_price) > Number(p?.price);

export const promoCountdown = (p) => {
  if (!hasPromo(p) || !p?.promo_ends_at) return null;
  const diff = new Date(p.promo_ends_at).getTime() - Date.now();
  if (Number.isNaN(diff) || diff <= 0) return null;
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  if (days > 1) return `tra ${days} giorni`;
  if (days === 1) return "tra 1 giorno";
  if (hours > 1) return `tra ${hours} ore`;
  return "in scadenza";
};

export const fetchPricing = async () => {
  try {
    const { data } = await api.get("/pricing");
    return data;
  } catch {
    return DEFAULT_PRICING;
  }
};
